import { EntLeasingRegisterFilter } from "../../../models/filters/leasingRegisterFilter";
import { EntLeasingRegister } from "../../../models/mechanization/leasingRegister";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { Paths } from "../../../paths";

export const leasingRegisterApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({

	getLeasingRegisterListFiltered: builder.query<ResponseDataGet<EntLeasingRegister>, EntLeasingRegisterFilter>({
	  query: (filter) => ({
		url: `${ Paths.mechanization.leasingregister }/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),
	getLeasingRegisterList: builder.query<ResponseDataGet<EntLeasingRegister>, void>({
	  query: () => ({
		url: `${ Paths.mechanization.leasingregister }`,
		method: 'GET'
	  })
	}),
	getLeasingRegisterById: builder.query<ResponseDataTest<EntLeasingRegister>, number>({
	  query: (id) => ({
		url: `${ Paths.mechanization.leasingregister }/${ id }`,
		method: 'GET'
	  })
	}),
	addLeasingRegister: builder.mutation<ResponseDataTest<EntLeasingRegister>, EntLeasingRegister>({
	  query: (body) => ({
		url: `${ Paths.mechanization.leasingregister }`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editLeasingRegister: builder.mutation<ResponseDataTest<EntLeasingRegister>, EntLeasingRegister>({
	  query: (body) => ({
		url: `${ Paths.mechanization.leasingregister }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deleteLeasingRegister: builder.mutation<ResponseDataTest<EntLeasingRegister>, number>({
	  query: (id) => ({
		url: `${ Paths.mechanization.leasingregister }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddLeasingRegisterMutation,
  useDeleteLeasingRegisterMutation,
  useEditLeasingRegisterMutation,
  useLazyGetLeasingRegisterListFilteredQuery
} = leasingRegisterApi;
